import { Component } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = 'IMSSchool';
  constructor(private router: Router) {

  }
  ngOnInit(): void {
    if (localStorage.length == 0 //&& window.location.hash.toString().toUpperCase() != "#/SCHOOLLOGIN" 
      && !(window.location.hash.toString().toUpperCase().includes("#/COLLEGELOGIN")
         || (window.location.hash.toString().toUpperCase().includes("#/")) 
         || (window.location.hash.toString() == "") )) {
      this.router.navigate(['/aciadmin']);
      return;
    }
  }
}
